import { useEffect, useState } from "react";

function getRemaining(target) {
  const diff = new Date(target).getTime() - Date.now();
  if (isNaN(diff)) return null;
  if (diff <= 0) return { done: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { done: false, days, hours, minutes, seconds };
}

const pad = (n) => String(n).padStart(2, "0");

function Unit({ value, label, testid }) {
  return (
    <div className="flex flex-col items-center" data-testid={testid}>
      <div className="flex h-16 w-full min-w-[3.5rem] items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] font-display text-2xl font-black tabular-nums text-white sm:h-20 sm:text-3xl">
        {pad(value)}
      </div>
      <span className="mt-2 font-mono text-[10px] uppercase tracking-[0.18em] text-gray-500">{label}</span>
    </div>
  );
}

// Live countdown to presale start. Pass an ISO date string via `target`.
export default function CountdownTimer({ target, className = "" }) {
  const [remaining, setRemaining] = useState(() => getRemaining(target));

  useEffect(() => {
    setRemaining(getRemaining(target));
    const id = setInterval(() => setRemaining(getRemaining(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!remaining) return null;

  const startLabel = new Date(target).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });

  return (
    <div className={className} data-testid="presale-countdown">
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-indigo-300">
          {remaining.done ? "Presale Is Live" : "Presale Starts In"}
        </span>
        <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-gray-500">
          {startLabel}
        </span>
      </div>
      {remaining.done ? (
        <div className="mt-3 flex items-center gap-2.5 rounded-xl border border-emerald-400/20 bg-emerald-400/5 px-4 py-4">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-70" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
          </span>
          <span className="font-display text-sm font-bold uppercase tracking-tight text-emerald-200">
            The presale is now open
          </span>
        </div>
      ) : (
        <div className="mt-3 grid grid-cols-4 gap-2 sm:gap-3">
          <Unit value={remaining.days} label="Days" testid="countdown-days" />
          <Unit value={remaining.hours} label="Hours" testid="countdown-hours" />
          <Unit value={remaining.minutes} label="Minutes" testid="countdown-minutes" />
          <Unit value={remaining.seconds} label="Seconds" testid="countdown-seconds" />
        </div>
      )}
    </div>
  );
}
